import React, { useState } from "react";
import { configurations } from "../../../configurations";

function CommonConfirmationProductDetailSection({ data = [] }) {
  return (
    <div className="w-full flex flex-col gap-3">
      {data?.map((item, index) => (
        <SingleProductDetail key={index} item={item} index={index} />
      ))}
    </div>
  );
}

export default CommonConfirmationProductDetailSection;

const SingleProductDetail = ({ item, index }) => {
  const [showDetail, setShowDetail] = useState(false);
  const icon = () => {
    switch (item?.type) {
      case configurations.services.stay.value:
        return "/IconHotel2.svg";
      case configurations.services.flight.value:
        return "/IconFlight2.svg";
      case configurations.services.tour.value:
        return "/IconTour2.svg";
      case configurations.services.insurance.value:
        return "/IconInsurance2.svg";
      default:
        return "/IconTour2.svg";
    }
  };
  return (
    <div className="w-full p-4 bg-white border flex-wrap border-gray-300 rounded-lg items-center flex gap-2 justify-between">
      <div className="w-6 h-6 text-white bg-primary1 font-bold text-sm rounded-md flex items-center justify-center">
        {index + 1}
      </div>
      <div className="flex flex-col items-start w-[350px] flex-1">
        <div className="flex items-center gap-1">
          <img src={icon(item?.type)} alt="" className="h-5 object-contain" />
          <span className=" font-bold">{item?.title}</span>
        </div>
        <div className="flex items-center gap-1 -ml-1">
          <img
            src="/IconLocationPrimary.svg"
            alt=""
            className="w-5 object-contain"
          />
          <span className=" text-sm text-[#6D7C94]">{item?.address}</span>
        </div>
      </div>
      <div
        className={`flex w-full ${
          item?.mainDetailWidth || "lg:flex-1 lg:w-fit"
        } justify-between gap-2"`}
      >
        {item?.mainDetails?.map((detail, detailIndex) => (
          <div className="flex flex-col" key={detailIndex}>
            <span className="text-sm text-gray-500">{detail?.label}</span>
            <span className="text-sm font-bold">{detail?.value}</span>
          </div>
        ))}

        <div className="flex flex-col">
          <button
            className="flex items-center"
            onClick={() => setShowDetail(!showDetail)}
          >
            <span className="text-sm text-gray-500">Details</span>
            <img
              src="/IconChevronDown.svg"
              alt=""
              className={`w-4 object-contain ${showDetail && "rotate-180"}`}
            />
          </button>
          <div></div>
        </div>
      </div>
      {item?.mainMore}
      {showDetail && item?.detailWithIcon && (
        <div className="w-full flex justify-between flex-col gap-2 border-t pt-2 border-gray-300 lg:px-8">
          {item?.detailWithIcon?.map((detail, index) => (
            <div className="flex gap-2 items-center" key={index}>
              <img
                src={detail?.icon}
                alt=""
                className="w-4 h-4 object-contain"
              />
              <span className="text-sm text-gray-500">{detail?.value}</span>
            </div>
          ))}
        </div>
      )}
      {showDetail && item?.moreDetailWithIcon && (
        <div className="w-full flex flex-wrap gap-2 lg:gap-4 border-t pt-2 border-gray-300 lg:px-8">
          {item?.moreDetailWithIcon?.map((detail, index) => (
            <div className="flex gap-2 items-center" key={index}>
              <img
                src={detail?.icon}
                alt=""
                className="w-4 h-4 object-contain"
              />
              <span className="text-sm text-gray-500">{detail.value}</span>
            </div>
          ))}
        </div>
      )}
      {showDetail && item?.cancellationPolicy && (
        <div className="w-full flex flex-wrap gap-2 lg:gap-4 pt-2 lg:px-8">
          {item?.cancellationPolicy && (
            <div className="flex bg-blue-600/10 rounded-md w-full py-4 px-4 flex-col mb-2">
              <span className="text-base font-bold mb-1">
                {item?.cancellationPolicy?.title}
              </span>
              <div className="flex items-center gap-2 text-sm text-gray-600">
                <img src="/IconCheckmark1.svg" alt="" />
                <span className="text-xs">
                  {item?.cancellationPolicy?.description}
                </span>
              </div>
            </div>
          )}
        </div>
      )}
      {showDetail && item?.moreDetails && (
        <div className="w-full flex justify-between flex-wrap gap-2 border-t pt-2 border-gray-300 ">
          {item?.moreDetails?.map((moreDetail, moreDetailIndex) => (
            <div className="flex flex-col" key={moreDetailIndex}>
              <span className="text-sm text-gray-500">{moreDetail.label}</span>
              <span className="text-sm font-bold">{moreDetail.value}</span>
            </div>
          ))}

          {item?.comments ? (
            <div className="w-full flex gap-2 flex-wrap mt-2">
              {item?.comments?.map((comment) => (
                <div className="text-[10px] lg:text-xs rounded-md p-3 bg-blue-500/10 w-fit">
                  {comment}
                </div>
              ))}
            </div>
          ) : (
            <></>
          )}
        </div>
      )}
      {showDetail && item?.detailComponent}
    </div>
  );
};
